export default __webpack_public_path__ + "static/media/ios-screen2.4ffbb793.png";